module.exports = __webpack_public_path__ + "365bcacd37e7c9429c4387e6e8d717bd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/tree-bottom.png
// module id = 1410
// module chunks = 0